uniform vec3 uBaseColor;
uniform float uSize;
uniform float uTime;
uniform float uSpeed;
uniform float uStep;
uniform float uStepRange;
uniform float uBaseColorPower;
uniform float uDirection;
uniform float uOpacity;
uniform float uDistortion;
varying float vCarrierDistance;

varying vec2 vUv;

void main() {
  float opacity = pow(sin((vUv.y + uTime * uSpeed * uDirection) * (1. / uSize)), 2.);
  opacity = smoothstep(uStep - uStepRange, uStep + uStepRange, opacity);
  opacity += 0.1;

  float distortion = sin(((vUv.y - 0.55) * 0.5 + uTime * uSpeed * uDirection * 0.5) * (1. / uSize));
  distortion *= sin(((vUv.y - 0.5) * 0.5 + uTime * uSpeed * uDirection * 0.5) * (1. / uSize)), 2.;
  distortion = smoothstep(uStep - uStepRange * 3., uStep + uStepRange * 3., distortion);
  distortion *= 1.75;

  opacity += distortion * uDistortion;

  gl_FragColor = vec4(uBaseColor * uBaseColorPower + distortion * uDistortion, opacity * uOpacity);
  // gl_FragColor = vec4(uBaseColor * uBaseColorPower, distortion * uOpacity);
}